/* eslint-disabled */

import DataType from "@/entity/DataType";
import Popup from "@/entity/Popup";
import Question from "@/entity/Question";
import QuestionType from "@/entity/QuestionType";
import Response from "@/entity/Response";
import ResponseGroup from "@/entity/ResponseGroup";
import Survey from "@/entity/Survey";
import Tag from "@/entity/Tag";
import {auth} from "@/services/Auth";
import {helper} from "@/services/Helper";
import store from "@/store";

export default class QuestionExtend {
    visibility = "PUBLIC";
    response = new Response();
    message: any = null;
    isValid = false;
    isSending = false;
    public surveySlug = "";
    public branchSlug = "";
    public genId = helper.generateId();
    public ariane: any[] = [];
    public sent: any = null;
    public type!: DataType;
    public mapped = false;
    typeCode = "";

    constructor(object?: any) {
        if (object) {
            this.surveySlug = object.surveySlug;
            this.branchSlug = object.branchSlug;
            this.type =
                object.type instanceof QuestionType
                    ? object.type
                    : new DataType(object.type);
            if (object.response) {
                this.response = new Response(object.response);
            }
            this.typeCode = object.typeCode;
        }
    }

    postConstruct() {
        const self: Question = this as any;

        if (self.defaultValue && helper.empty(self.response.value)) {
            // self.response.value = self.defaultValue
        }
        if (self.response.value) {
            self.response.currentValue = self.response.value;
        }
        this.response.questionUuid = self.uuid;
        this.validate();
    }

    async setDefaultValue(rg: any = null) {
        const self: Question = this as any;
        // Ne pas écraser une réponse existante (déjà sauvegardée en base)
        if (self.response?.uuid) return;
        // Ne pas appliquer la defaultValue si la question est cachée par condition :
        // évite de pousser une valeur fantôme au backend qui sera ensuite supprimée.
        if (!self.isVisible()) return;
        if (!helper.empty(self.defaultValue) && helper.empty(self.response.value)) {
            self.response.value = self.defaultValue;
            if (rg instanceof ResponseGroup) {
                self.response.responseGroup = rg;
            }
            if (this.hasChange()) {
                await this.updateAnswer(true);
                store.commit("checkStepValidation");
            }
        }
    }

    getQuestions() {
        const self: Question = this as any;

        if (
            self.type.code.match(/OBJECT/) &&
            self.survey &&
            typeof self.survey.getQuestions === "function"
        ) {
            const questions = self.survey.getQuestions();

            questions.push(self);
            return questions;
        } else {
            return [self];
        }
    }

    typeHasTag(tag: string) {
        let found = false;
        (this as any).type.tags.forEach((t: Tag) => {
            if (t.label === tag) {
                found = true;
            }
        });
        return found;
    }

    hasTag(tag: string) {
        const self: Question = this as any;
        let found = false;
        self.tags.forEach((t: Tag) => {
            if (t.label === tag) {
                found = true;
            }
        });
        return found;
    }

    hasChange(): boolean {
        const self: Question = this as any;
        if (self.type.code === "NUMBER") {
            if (!Number.isInteger(parseFloat(self.response.value as any))) {
                const newValue = this.convertFloatToInteger(
                    parseFloat(self.response.value as any)
                );
                const currentValue = this.convertFloatToInteger(
                    parseFloat(self.response.currentValue as any)
                );
                return newValue !== currentValue;
            }
        }
        return self.response.currentValue !== self.response.value;
    }

    convertFloatToInteger(value: number) {
        let s: any = "" + value;
        if (s.includes(".")) {
            s = s.split(".");
            const decimalCount = s.slice(-1).length;
            const multiplicator = Math.pow(10, decimalCount);
            return parseFloat(value as any) * multiplicator;
        }
        return value;
    }

    isAuthorized() {
        const self: Question = this as any;

        if (self.visibility !== "PUBLIC") {
            if (!auth.hasRole("ROLE_" + self.visibility)) {
                return false;
            }
        }

        if (self.requiredRoles && self.requiredRoles.length > 0) {
            if (!auth.hasRole("ROLE_" + self.visibility)) {
                return false;
            }
        }
        return true;
    }

    static _visibilityStack: Set<any> = new Set();

    isVisible() {
        const self: Question = this as any;
        const survey: Survey = store.state.mainStore.currentSurvey;
        const rg: ResponseGroup = store.state.mainStore.currentResponseGroup;

        // Si le survey n'est pas défini, n'a pas la méthode getQuestions, ou n'a pas de conditionGroups, la question est visible par défaut
        if (
            !survey ||
            typeof survey.getQuestions !== "function" ||
            !self.conditionGroups ||
            self.conditionGroups.length === 0
        ) {
            return true;
        }

        let decision = null;
        for (let conditionGroup of self.conditionGroups) {
            let cg = true;
            for (let condition of conditionGroup.conditions) {
                const testRef = condition.testingQuestion || (condition as any).question;
                const testingQuestion: Question = survey
                    .getQuestions()
                    ?.find((q: Question) => {
                        return q.uuid === testRef
                            || String(q.id) === String(testRef);
                    }) as any;

                if (!testingQuestion) {
                    cg = false;
                } else if (testingQuestion.conditionGroups?.length > 0 && !QuestionExtend._visibilityStack.has(testingQuestion.id)) {
                    QuestionExtend._visibilityStack.add(self.id);
                    const testVisible = testingQuestion.isVisible();
                    QuestionExtend._visibilityStack.delete(self.id);
                    if (!testVisible) {
                        cg = false;
                    }
                }
                if (cg && testingQuestion && (!testingQuestion.response || !testingQuestion.response.value)) {
                    cg = false;
                }

                if (
                    testingQuestion &&
                    testingQuestion.response &&
                    testingQuestion.response.value
                ) {
                    switch (condition.operator) {
                        case "===": {
                            cg =
                                cg &&
                                testingQuestion.response.value!.toUpperCase() ===
                                condition.value!.toUpperCase();
                            break;
                        }
                        case "!==": {
                            cg =
                                cg &&
                                testingQuestion.response.value!.toUpperCase() !==
                                condition.value!.toUpperCase();
                            break;
                        }
                        case "<": {
                            cg =
                                cg &&
                                parseFloat(testingQuestion.response.value!) <
                                parseFloat(condition.value);
                            break;
                        }
                        case "<=": {
                            cg =
                                cg &&
                                parseFloat(testingQuestion.response.value!) <=
                                parseFloat(condition.value);
                            break;
                        }
                        case ">": {
                            cg =
                                cg &&
                                parseFloat(testingQuestion.response.value!) >
                                parseFloat(condition.value);
                            break;
                        }
                        case ">=": {
                            cg =
                                cg &&
                                parseFloat(testingQuestion.response.value!) >=
                                parseFloat(condition.value);
                            break;
                        }
                    }
                } else {
                    cg = false;
                }
            }
            decision = decision === null ? cg : decision || cg;
        }

        if (decision === null) {
            decision = true;
        }
        (self as any)._wasVisible = decision;
        return decision;
    }

    // Purge la valeur d'une question qui vient de devenir cachée.
    // A appeler en dehors du cycle de rendu (watcher, nextTick, etc.)
    clearIfHidden() {
        const self: Question = this as any;
        if (!self.isVisible() && self.response && self.response.value) {
            self.response.value = null;
            self.response.currentValue = null;
        }
    }

    isVisibleIn(survey: Survey, rg: ResponseGroup) {
        const self: Question = this as any;

        // Vérifier que le survey a la méthode getQuestions
        if (!survey || typeof survey.getQuestions !== "function") {
            return true;
        }

        let decision = null;
        for (let conditionGroup of self.conditionGroups) {
            let cg = true;
            for (let condition of conditionGroup.conditions) {
                const testRef2 = condition.testingQuestion || (condition as any).question;
                const testingQuestion: Question = survey
                    .getQuestions()
                    .find((q: Question) => {
                        return q.uuid === testRef2 || String(q.id) === String(testRef2);
                    }) as any;
                if (testingQuestion) {
                    if (testingQuestion.response && testingQuestion.response.value) {
                    } else {
                        const res = rg.responses.find((r: Response) => {
                            return r.question?.uuid === testingQuestion.uuid;
                        });
                        if (res) {
                            testingQuestion.response = res;
                        }
                    }
                }
                if (
                    testingQuestion &&
                    testingQuestion.response &&
                    testingQuestion.response.value
                ) {
                    switch (condition.operator) {
                        case "===": {
                            cg =
                                cg &&
                                testingQuestion.response.value!.toUpperCase() ===
                                condition.value!.toUpperCase();
                            break;
                        }
                        case "!==": {
                            cg =
                                cg &&
                                testingQuestion.response.value!.toUpperCase() !==
                                condition.value!.toUpperCase();
                            break;
                        }
                        case "<": {
                            cg =
                                cg &&
                                parseFloat(testingQuestion.response.value!) <
                                parseFloat(condition.value);
                            break;
                        }
                        case "<=": {
                            cg =
                                cg &&
                                parseFloat(testingQuestion.response.value!) <=
                                parseFloat(condition.value);
                            break;
                        }
                        case ">": {
                            cg =
                                cg &&
                                parseFloat(testingQuestion.response.value!) >
                                parseFloat(condition.value);
                            break;
                        }
                        case ">=": {
                            cg =
                                cg &&
                                parseFloat(testingQuestion.response.value!) >=
                                parseFloat(condition.value);
                            break;
                        }
                    }
                } else {
                    cg = false;
                }
            }
            decision = decision === null ? cg : decision || cg;
        }

        if (decision === null) {
            decision = true;
        }
        return decision;
    }

    async updateAnswer(isDefault: boolean = false) {
        const self: Question = this as any;

        if (!this.hasChange() || this.sent === self.response.value) {
            return;
        }

        this.validate();
        if (!this.isValid) {
            return;
        }

        const rgUuid = self.response.responseGroup?.uuid
            || self.response.responseGroupUuid
            || store.state.formStore?.currentResponseGroupUuid;

        if (!rgUuid) {
            return;
        }

        this.isSending = true;
        this.sent = self.response.value;

        // Write to formStore — immediate reactive update + queued batch save
        store.dispatch("formStore/updateResponse", {
            rgUuid,
            questionId: self.id,
            questionUuid: self.uuid,
            value: self.response.value,
        });

        // Update local instance to stay in sync
        self.response.currentValue = self.response.value;
        self.response.questionUuid = self.uuid;

        // Notify mainStore for UI reactivity (step validation, progress)
        store.commit("responseSaved");
        if (!isDefault) {
            store.commit("onlineResponseSaved");
        }

        this.isSending = false;
    }

    validate() {
        const self: Question = this as any;
        this.message = null;
        // @ts-ignore
        if (this.required && helper.empty(this.response.value)) {
            this.message = "Ce champs est réquis";
        }
        if (self.type && self.type.code === "DATE") {
            if (!helper.empty(this.response.value) && !helper.isValidDate(this.response.value)) {
                this.message = "Date invalide";
            }
        }
        // Valide seulement si pas d'erreur ET une réponse existe
        this.isValid = this.message === null && !helper.empty(this.response.value);
        return this.isValid;
    }

    validateCurrent(invalid = []) {
        let valid = false;
        const self: Question = this as any;
        if (!self.isVisible()) {
            return true;
        }
        this.message = null;
        // @ts-ignore
        if (this.required && helper.empty(this.response.currentValue)) {
            this.message = "Ce champs est réquis";
        }
        if (self.type && self.type.code === "DATE") {
            if (!helper.isValidDate(this.response.currentValue)) {
                this.message = "Date invalide";
            }
        }

        if (this.message === null) {
            valid = true;
        } else {
            valid = false;
        }
        if (!valid) {
            invalid.push(this);
        }
        return valid;
    }

    comeBefore(question: Question) {
    }

    save() {
    }
}
